module.exports = __webpack_public_path__ + "img/Hungarian-Horntail.695ab22a.png";